 const constants = {
    CATEGORIES_DATA:'CATEGORIES_DATA',
    POST_DATA:'POST_DATA',
    PAGE_DATA: 'PAGE_DATA',
    HUMAN_DATA: 'HUMAN_DATA',
    HUMAN_POST_DATA: 'HUMAN_POST_DATA'
}
export default constants;